import { ShieldAlert, ShieldCheck, ShieldX } from '@orgus/ui/icons';
import type { Risk } from '@orgus/protocol';
import { RISK_LABEL, cn } from '@orgus/ui';

const ICON = { low: ShieldCheck, medium: ShieldAlert, high: ShieldX } as const;
const WORD: Record<Risk, string> = { low: 'Low', medium: 'Medium', high: 'High' };

/**
 * A request's risk in a row (ADR 0072): every level, as a small label with its own shield, so
 * levels differ by shape too. Quiet for low and medium; only high takes the danger ink.
 */
export function RiskLabel({ risk, className }: { risk: Risk; className?: string }) {
  const Icon = ICON[risk];
  return (
    <span data-chip className={cn('inline-flex shrink-0 items-center gap-1 text-caption', risk === 'high' ? 'font-medium text-status-danger' : risk === 'medium' ? 'text-fg-muted' : 'text-fg-subtle', className)} title={RISK_LABEL[risk]}>
      <Icon className="size-3" aria-hidden />
      <span>
        {WORD[risk]}
        <span className="sr-only"> risk</span>
      </span>
    </span>
  );
}
